import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi, InvalidateArr } from '@/modules';
import { ConsultationStatService } from './consultation.service';
import {
  ConsultationStat,
  ConsultationStatCode,
  GroupedConsultationStats
} from './consultation.model';
import { wrapError } from '../../error';
import { constructProtocolCacheKey, ProtocolName } from '@/modules/protocol';

export const consultationStatsApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    consultationStats: builder.query<GroupedConsultationStats, PatientId>({
      queryFn: ({ patientId }) =>
        ConsultationStatService.getInstance(patientId)
          .fetchGrouped<ConsultationStatCode, false>()
          .catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'ConsultationStat', id: patientId }
      ]
    }),

    upsertConsultationStat: builder.mutation<
      ConsultationStat[],
      WithPatientId<Partial<ConsultationStat>>
    >({
      queryFn: ({ patientId, ...stat }) =>
        ConsultationStatService.getInstance(patientId)
          .upsert(stat)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId, code }) => {
        if (error) {
          return [];
        }

        const arr: InvalidateArr = [
          { type: 'ConsultationStat', id: patientId },
          { type: 'MedicalHo', id: patientId },
          { type: 'Scores', id: patientId },
          { type: 'SurgeryInfo', id: patientId }, // for ASA prediction update
          { type: 'ProtocolStatuses', id: patientId },
          {
            type: 'Protocol',
            id: constructProtocolCacheKey({
              patientId,
              protocol: ProtocolName.NUTRITION
            })
          },
          'Dashboard'
        ];

        if (code === ConsultationStatCode.WEIGHT_KG) {
          // for anemia co-pilot update
          arr.push({
            type: 'Protocol',
            id: constructProtocolCacheKey({
              patientId,
              protocol: ProtocolName.ANEMIA
            })
          });
        }

        return arr;
      }
    })
  }),
  overrideExisting: false
});

export const { useConsultationStatsQuery, useUpsertConsultationStatMutation } =
  consultationStatsApi;
